import { Component, Inject } from '@angular/core';
import { Diagnostic, IEventHandler } from '@lmnop/web-core';
import { ControlBase } from '../../../base/control-base/control-base.component';
import { CoreService_TOKEN, ICoreService, News } from 'angular-core-src';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { NewsModel } from '../../../../types/news.model';

@Component({
    selector: 'news-list-control',
    templateUrl: 'news-list.control.html',
    styleUrl: './news-list.control.scss',
    standalone: false,
})
export class NewsListControl extends ControlBase {
    private static FORTY_EIGHT_HOURS_MS = 48 * 60 * 60 * 1000;

    //TODO SOON: newslist kontrol csak az id-ket tárolja + a dátumot + az egy évnél régebbi híreket elvetni, a tároltból is kitakarítani ha eltelt egy év
    constructor(
        @Inject(CoreService_TOKEN)
        private coreService: ICoreService,
        protected override spinnerService: NgxSpinnerService
    ) {
        super(spinnerService);
        this.onNewsReadChange = this.ioc.core.eventHandler;
    }

    public static NEWS_READ_CHANGED_EVENT: string = 'news_read_changed';
    public onNewsReadChange: IEventHandler;

    public get newsList(): News[] {
        return [...this.settings.newsList].sort((a, b) => {
            return Number(a.isRead) - Number(b.isRead);
        });
    }

    public get showNews(): boolean {
        return this.newsList.length > 0;
    }

    public get allNewsAsRead(): boolean {
        return this.settings.newsList.every(n => n.isRead);
    }

    public ngOnInit(): void {
        this.refreshNewsIfNeeded();
    }

    private saveListToStorage() {
        this.settings.updateSettingsInStorage();
        this.onNewsReadChange.emit(NewsListControl.NEWS_READ_CHANGED_EVENT);
    }

    public markNewsAsRead(news: News): void {
        news.isRead = true;
        news.className = 'isRead';
        this.saveListToStorage();
    }

    public markAllNewsAsRead(): void {
        this.newsList.forEach(news => {
            news.isRead = true;
            news.className = 'isRead';
        });
        this.saveListToStorage();
    }

    public getNews = async (): Promise<any> => {
        return firstValueFrom(this.coreService.getNewsList())
            .then(res => {
                let newsModelList: NewsModel[] = [];
                newsModelList = res.result;

                if (newsModelList.length === 0) {
                    return;
                }

                this.setNewsList(newsModelList);
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
            });
    };

    private setNewsList(newsModelList: NewsModel[]): void {
        for (let item of newsModelList) {
            let existNews: boolean = this.settings.newsList.some(n => n.guid === item.guid);
            if (!existNews) {
                let newsItem: News = new News();
                newsItem.guid = item.guid;
                newsItem.title = item.title;
                newsItem.content = item.content;
                newsItem.isRead = false;

                this.settings.newsList.push(newsItem);
                this.settings.lastNewsFetchAt = new Date();

                this.settings.updateSettingsInStorage();
            }
        }
    }

    private refreshNewsIfNeeded(): void {
        let lastNewsFetchAt = new Date(this.settings.lastNewsFetchAt);
        let now = new Date();
        let has48HoursPassed = now.getTime() - lastNewsFetchAt.getTime() >= NewsListControl.FORTY_EIGHT_HOURS_MS;
        if (has48HoursPassed) {
            this.settings.lastNewsFetchAt = new Date();
            this.getNews();
        }
    }
}
